import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=af5b22a4"
import script from "./MainTitle.vue?vue&type=script&lang=js"
export * from "./MainTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports